export default __webpack_public_path__ + "static/media/isokuva2.0048d0fa.jpg";